/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';
import history from './utils/history';
import globalReducer from './containers/App/reducer';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const { routerReducer } = createReduxHistoryContext({
    history,
  });

  const rootReducer = combineReducers({
    language: null,
    global: globalReducer,
    router: routerReducer,
    ...injectedReducers,
  });

  return rootReducer;
}
